import { render, staticRenderFns } from "./ConcessionAdd.vue?vue&type=template&id=39ce0368&scoped=true&"
import script from "./ConcessionAdd.vue?vue&type=script&lang=js&"
export * from "./ConcessionAdd.vue?vue&type=script&lang=js&"
import style0 from "./ConcessionAdd.vue?vue&type=style&index=0&id=39ce0368&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ce0368",
  null
  
)

export default component.exports